import { useEffect, useState } from 'react';
import type { SlashCommand } from '@rmint/shell';

// Admin slash commands are entirely server-backed (admin-agent tools). Unlike
// outreach there are no client-only static commands (no /prospect scope-switch
// — admin has no scope). Tools come from /admin-agent/tools and are merged in.
export function useSlashRegistry(): SlashCommand[] {
  const [serverCommands, setServerCommands] = useState<SlashCommand[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetch('/admin-agent/tools')
      .then((res) => (res.ok ? (res.json() as Promise<{ tools: SlashCommand[] }>) : { tools: [] }))
      .then((data) => {
        if (!cancelled) setServerCommands(data.tools);
      })
      .catch(() => {
        /* leave empty — slash menu shows nothing until the agent is up */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return serverCommands;
}
